
import { Component, Vue, Prop } from 'vue-property-decorator';
import { useFollowList } from '@/helpers/composables/useFollowList';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';

@Component({
	name: 'ListToggle',
	setup() {
		const { toggleFollowList } = useFollowList();
		return { toggleFollowList };
	},
})
export default class ListToggle extends Vue {
	faBookmark = faBookmark;

	@Prop() isFollowed: boolean;
	@Prop() listId: string;
	@Prop() listName: string;

	declare toggleFollowList: ({
		listId,
		isFollowed,
		listName,
	}: {
		listId: string;
		isFollowed: boolean;
		listName: string;
	}) => Promise<any>;

	async onFollowToggle() {
		await this.toggleFollowList({
			listId: this.listId,
			listName: this.listName,
			isFollowed: this.isFollowed,
		});
		this.$emit('click');
	}
}
